import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { WhiteBox } from '@/components/Layout'
import Comments from '@/components/comments/Comments'
import LoadingIndicator from '@/components/LoadingIndicator'
import Resx from '@/components/Resx'

class EntityComments extends React.Component {
  static propTypes = {
    localize: PropTypes.func.isRequired,
    parentId: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    showExternalVisibilityCheckbox: PropTypes.bool,
    entityComments: PropTypes.shape({
      fetching: PropTypes.bool,
      adding: PropTypes.bool,
      comments: PropTypes.array
    }),
    getComments: PropTypes.func.isRequired,
    addComment: PropTypes.func.isRequired,
    collapse: PropTypes.bool,
    collapsed: PropTypes.bool
  }
  constructor (props, context) {
    super(props, context)

    this.box = React.createRef()
  }
  componentDidMount () {
    this.reloadComments()
  }
  reloadComments () {
    this.props.getComments(this.props.parentId)
  }
  render () {
    const { localize, parentId, author, disabled, entityComments, showExternalVisibilityCheckbox, collapse, collapsed } = this.props
    const isLoading = (entityComments.fetching === true)

    return (

      <WhiteBox
        dataCy='EntityComments'
        header={localize('Common.Comments') + ' (' + entityComments.comments.length + ')'}
        buttons={<Button disabled={isLoading} onClick={() => this.reloadComments()} color='primary' className='btn btn-md'><Resx name='Common.Refresh' /></Button>}
        collapse={collapse}
        collapsed={collapsed}
      >
        {isLoading && <LoadingIndicator />}
        {!isLoading && <div ref={this.box} style={this.box.height}>
          <Comments
            author={author}
            disabled={disabled}
            comments={entityComments.comments}
            showExternalVisibilityCheckbox={showExternalVisibilityCheckbox}
            isAddingComment={entityComments.adding}
            onCommentCreated={newComment => this.props.addComment({ entityId: parentId, ...newComment })} />
        </div>}
      </WhiteBox>
    )
  }
}

export default EntityComments



// WEBPACK FOOTER //
// ./src/components/comments/EntityComments.js